import { render, staticRenderFns } from "./competitors-selector.vue?vue&type=template&id=4186a1af"
import script from "./competitors-selector.vue?vue&type=script&lang=js"
export * from "./competitors-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports